import getReadingTime from 'root/page/news/readingTime';
import shareSocial from 'root/page/news/socialMediaShare';
import searchModal from 'root/page/news/searchModal';

window.addEventListener('load', () => {
    getReadingTime().init();
    shareSocial().init();
    searchModal().init();
});
